<template>
    <Modal
        class="reward-modal"
        showHeaderSeparator
        :version="1"
        okButtonText="Apply"
        title="Edit Reward"
        v-on="listeners"
        v-bind="$props"
    >
        <div slot="modal-body">
            <div class="content-row">
                <label class="font-4">Placement</label>
                <span>{{ consts.ADUNIT_TO_NAME[adUnit] }} | {{ placementName }}</span>
            </div>
            <div class="content-row">
                <label class="font-4">Reward</label>
                <div>
                    <input type="number" min="1" step="1" v-model.number="reward"/>
                    {{ virtualItemName }}
                    <span class="default-text">
                        (Default: {{ defaultValue }} {{ virtualItemName }})
                    </span>
                </div>
            </div>
        </div>
        <div slot="modal-footer-content" class="footer-content">
            <button class="important" :class="{disabled: !fieldsChanged}" @click="revertClick">
                Revert to Default
            </button>
        </div>
    </Modal>
</template>

<script>
import Modal from 'components/modals/Modal.vue';
import consts from 'services/metaData/consts';

export default {
    name: 'RewardModal',
    components: { Modal },
    props: {
        ...Modal.props,
        adUnit: {
            required: true,
            validator: (val) => Object.keys(consts.ADUNIT_TO_NAME).includes(val)
        },
        placementId: {
            type: Number,
            required: true
        },
        placementName: {
            type: String,
            required: true
        },
        virtualItemName: {
            type: String,
            required: true
        },
        defaultValue: {
            type: Number,
            required: true
        },
        currentValue: Number
    },
    data() {
        return {
            reward: ''
        };
    },
    computed: {
        listeners() {
            return { ...this.$listeners, ok: this.emitOk };
        },
        fieldsChanged() {
            return this.reward !== this.defaultValue;
        },
        consts: () => consts
    },
    methods: {
        revertClick() {
            if (!this.fieldsChanged) return;
            this.$emit('ok', this.defaultValue);
        },
        emitOk() {
            this.$emit('ok', this.reward);
        },
        resetFields() {
            this.reward = this.currentValue || this.defaultValue;
        }
    },
    mounted() {
        this.resetFields();
    },
    watch: {
        open() {
            this.resetFields();
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~styles/styleGuide.scss";
@import "~styles/input.scss";
@import "~styles/buttons.scss";

.content-row {
    display: grid;
    grid-template-columns: 3fr 9fr;
    grid-column-gap: 5px;
    align-items: center;
    margin-top: 21px;

    input[type='number'] {
        width: 65px;
        padding-right: 0;
    }
}

.footer-content {
    padding-left: 25px;
    flex: 1;
}

.default-text {
    color: $light-800;
}

// Modal component style overrides
div.reward-modal ::v-deep {

    div.modal-container {
        width: 500px;
    }

    .modal-header {
        padding-top: 15px;
    }

    .modal-body {
        margin: 20px 16px 20px 18px;
        padding: 0;
    }
}
</style>
